<template>
    <div class="menu menu-sub menu-sub-dropdown w-250px w-md-300px" data-kt-menu="true">
        <div class="px-7 py-5">
            <div class="fs-5 text-dark fw-bolder">{{ $t('filters.title') }}</div>
        </div>

        <div class="separator border-gray-200"></div>

        <div class="px-7 py-5 overflow-auto max-h-300px">
            <div class="mb-10" v-if="!userID">
                <label class="form-label fw-bold">{{ $t('filters.customer.id') }}:</label>
                <div>
                    <el-input v-model="filterData.id" oninput="value=value.replace(/[^0-9.]/g,'')"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.customer.fullName') }}:</label>
                <div>
                    <el-input v-model="filterData.full_name" type="text"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.customer.mobilePhone') }}:</label>
                <div>
                    <el-input v-model="filterData.mobile_phone" type="text"/>
                </div>
            </div>
            <div class="mb-10">
                <label class="form-label fw-bold">{{ $t('filters.customer.containingModules') }}:</label>
                <div>
                    <el-select v-model="filterData.containing_modules" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                        <el-option v-for="(item, itemIndex) in modules" :key="itemIndex" :value="item.id" :label="item.name"></el-option>
                    </el-select>
                </div>
            </div>
        </div>

        <div class="separator border-gray-200"></div>

        <div class="px-7 py-5">
            <div class="d-flex justify-content-end">
                <button type="reset" v-on:click="onReset" class="btn btn-sm btn-white btn-active-light-primary me-2" data-kt-menu-dismiss="true">{{ $t('btn.reset') }}</button>
                <button type="submit" v-on:click="onFilter" class="btn btn-sm btn-primary" data-kt-menu-dismiss="true">{{ $t('btn.apply') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    data() {
        return {
            filterData: {},
            cities: []
        }
    },
    computed: {
        userID() {
            return this.$route.query.userID;
        },
        modules() {
            return this.$store.state.company.module.table.data;
        },
    },
    mounted() {
        if (this.userID) {
            this.filterData.id = this.userID;
        }

        this.$store.dispatch('company/module/get', {
            page: {
                pageSize: 9999
            }
        });
    },
    methods: {
        onReset() {
            this.filterData = {};
            this.onFilter();
        },
        onFilter() {
            this.$emit('onFilter', this.filterData);
        },
    }
}
</script>

<style>

</style>